<template>
  <div
    class="landing-page"
    :style="`background:url(${$root.cdnPath}/images/eg-bg-1.png) no-repeat;
        background-position: top center;
        background-repeat: no-repeat;
        height: 100%;
        background-size: cover;`"
  >
    <div class="header">
      Efsane Günler Özel
    </div>
    <div class="lp-box">
      <div class="landing-page-banner">
        <div class="landing-page-head">
          <h1>
            Yılın En Büyük Kampanyaları İçin İhtiyacınız Olan Her Şey Bu Sayfada!
          </h1>
          <div class="cta-wrapper">
            <a
              v-for="(button,index) in buttonDesc"
              @click="sendGtmData(button.gtmAction)"
              :key="'cta-action' + index"
              target="_blank"
              :href="button.link"
            >
              {{ button.title }}
            </a>
          </div>
        </div>
        <div class="landing-img">
          <img
            :src="`${$root.cdnPath}/images/eg-logo.png`"
            alt=""
          >
        </div>
      </div>
      <div class="landing-page-boxes">
        <h3 class="box-title">
          Promosyon Araçları ile Siz de Yılın En Büyük Kampanyalarında Yerinizi Alın!
        </h3>
        <div class="info-box-wrapper">
          <div
            class="info-box"
            v-for="(box,index) in campaignBoxes"
            :key="index"
          >
            <a
              class="info-box-cta"
              :href="box.link"
              target="_blank"
              @click="sendGtmData(box.gtmAction)"
            >
              <div class="desc-w-icon">
                <div
                  class="icon"
                  :style="`background-color:${box.iconBg}`"
                >
                  <Icon :name="box.icon" />
                </div>
                <div class="desc-box">
                  <div class="title">
                    {{ box.title }} <Icon name="chevron" />
                  </div>
                  <div class="desc">
                    {{ box.desc }}
                  </div>
                </div>
              </div>
              <img
                :src="`${$root.cdnPath}/images/${box.image}2x.png`"
                :alt="box.desc"
              >
            </a>
          </div>
        </div>
      </div>
      <div class="landing-page-boxes cta-box">
        <div
          :key="index"
          v-for="(boxBlock,index) in campaignCtaBoxes"
        >
          <h3 class="box-title">
            {{ boxBlock.title }}
          </h3>
          <div class="info-box-wrapper">
            <div
              class="info-box"
              v-for="(box,boxIndex) in boxBlock.boxes"
              :key="boxIndex"
            >
              <div class="box-icon">
                <Icon :name="box.icon" />
              </div>
              <h3>
                {{ box.title }}
              </h3>
              <p>
                {{ box.desc }}
              </p>
              <a
                :href="box.link"
                @click="sendGtmData(box.title)"
                target="_blank"
              >
                {{ box.buttonText }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="third-section">
        <div class="badge-image">
          <img
            :src="`${$root.cdnPath}/images/eg-badge.png`"
            alt=""
          >
        </div>
        <div class="card-wrapper">
          <div
            :key="index"
            class="section-card"
            v-for="(card,index) in campaignThird"
          >
            <img
              :src="`${$root.cdnPath}/images/${card.image}.png`"
              alt=""
            >
            <div class="info">
              <div class="title">
                {{ card.title }}
              </div>
              <div class="desc">
                {{ card.desc }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="slider-section"
      >
        <div class="title">
          Satıcılarımızın Süper İndirim Günleri Yorumları
        </div>
        <div class="comment-wrapper">
          <div
            class="slider-item"
            :key="index"
            v-for="(comment,index) in comments"
          >
            <div class="top">
              <img
                :src="`https://cdn.dsmcdn.com/seller-store/uploads/${comment.image}/logo.jpeg`"
                alt=""
              >
              <div class="customer">
                <div class="customer-name">
                  {{ comment.title }}
                </div>
              </div>
            </div>
            <div class="comment">
              {{ comment.desc }}
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        ©2022, DSM Grup Danışmanlık İletişim ve Satış Tic. A.Ş. Her hakkı saklıdır.
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
// eslint-disable-next-line import/extensions
import Icon from '@/components/Icon';

export default Vue.extend({
  name: 'CampaignLandingPage',
  components: {
    Icon,
  },
  data() {
    return {
      buttonDesc: [
        {
          title: 'Kasım 2022 Hedeflerimiz',
          link: 'https://tymp.mncdn.com/prod/documents/Trendyol_Kasim_2022_Isortagi_Sunumu.pdf',
          gtmAction: '2022 Kasım Hedefleri',
        },
        {
          title: 'Operasyon İpuçları',
          link: '/account/sso/lms?env=prod&domain=MP&url=/ContentRedirect/463',
          gtmAction: 'Operasyon İpuçları',
        },
        {
          title: 'Ödemenizi Erkenden Alın',
          link: '/payments/early-payments/contract',
          gtmAction: 'Erken Ödeme',
        },
      ],
      campaignBoxes: [
        {
          title: 'Kampanyalar',
          icon: 'campaign',
          iconBg: '#FEF2E8',
          desc: 'Kasım kampanyalarına katılanlar satışlarını 5 kata kadar   artırıyor!',
          image: 'campaign',
          link: '/promotions/campaigns/available',
          buttonText: 'Detaylı Bilgi',
          gtmAction: 'Kampanya',
        },
        {
          title: 'Tekliflerim',
          icon: 'offer',
          iconBg: '#FFEEEC',
          desc: 'Ürünlerinize özel komisyon indirimli ve 3 saatte 1 tekliflerle satışınızı katlayın!',
          image: 'offer',
          link: '/promotions/offers/available',
          buttonText: 'Kampanyaya Katıl',
          gtmAction: 'Tekliflerim',
        },
        {
          title: 'İndirim Oluştur',
          icon: 'discount',
          iconBg: '#F4EDFF',
          desc: 'Size uygun kriterleri dilediğiniz gibi belirleyerek kendi kampanyanızı oluşturun!',
          image: 'discount',
          link: '/promotions/basket-promotions',
          buttonText: 'Tekliflerini Gör',
          gtmAction: 'İndirim Oluştur',
        },
        {
          title: 'Kupon Oluştur',
          icon: 'coupon',
          iconBg: '#E7F9EF',
          desc: 'Kupon oluşturarak müşterilerinizin sepet tutarlarını %20 oranında artırabilirsiniz!',
          image: 'coupon',
          link: '/promotions/coupons',
          buttonText: 'Etiket Fiyatlarını Gör',
          gtmAction: 'Kupon Oluştur',
        },
      ],
      campaignCtaBoxes: [
        {
          title: 'Görünürlüğünüzü Artırarak Ürünlerinizi Daha Fazla Müşteriye Ulaştırın!',
          boxes: [
            {
              title: 'Reklam Yönetimi',
              desc: 'Reklam verip mağazanızın ziyaretçilerle dolmasını sağlayın!',
              link: '/seller-ads',
              buttonText: 'Hemen Reklam Ver',
              icon: 'ads',
            },
            {
              title: 'Otomatik Fiyatlandırma',
              desc: 'Buybox kazanabilmeniz için her şey tek sayfada toplandı!',
              link: '/auto-pricing/landing',
              buttonText: 'Otomatik Fiyatlandırma Tanımla',
              icon: 'pricing',
            },
            {
              title: 'Mağaza Yönetimi',
              desc: 'Mağaza tasarımınızı kasıma özel hazırlayın, müşterilerin satın olma oranını %10 \'a kadar artırın!',
              link: '/seller-store',
              buttonText: 'Mağazayı Güncelle',
              icon: 'store',
            },
            {
              title: 'Hızlı Teslimat',
              desc: 'Müşterilerimizin %84\'ü Hızlı Teslimat etiketli ürünleri tercih ediyor.',
              link: '/fast-delivery',
              buttonText: 'Hızlı Teslimat\'ı İncele',
              icon: 'truck',
            },
          ],
        },
        {
          title: 'Performansınızı Anlık Olarak Takip Edin ve İyileştirme Aksiyonları Alın!',
          boxes: [
            {
              title: 'Canlı Performansım',
              desc: 'Kampanya performansınızı anlık takip edin, aksiyonlarınızı hemen alın!',
              link: '/business-advisor/live-monitor/dashboard',
              buttonText: 'Canlı Performansıma Git',
              icon: 'monitor',
            },
            {
              title: 'Favorilenen Ürünler',
              desc: 'Favorilenen ürünleriniz için en uygun kampanyayı oluşturun!',
              link: '/business-advisor/sales-enhancer/visit-fav',
              buttonText: 'Hemen İncele',
              icon: 'hearth',
            },
            {
              title: 'Hedeflerim',
              desc: 'Size özel atanan hedeflerle Kasım\'da işinizi büyütün!\n',
              link: '/growth-center/challenges/approved',
              buttonText: 'Hedeflerime Git',
              icon: 'growth',
            },
            {
              title: 'Sepette Bekleyen Ürünler',
              desc: 'Sepette bekleyen ürünlerinize indirim oluşturun ve satışlarınızı hızlandırın!',
              link: '/business-advisor/diagnoses/sepette-bekleyen-urunler',
              buttonText: 'Hemen İncele',
              icon: 'market',
            },
          ],
        },
      ],
      campaignThird: [
        {
          title: 'Kasım Kampanyalarında İhtiyacınız Olan Her Şey Tek Bir Sayfada!',
          desc: 'Tüm bu önerilerimiz harika bir Kasım dönemi geçirmeniz için hazırlandı. Siz de herkesin beklediği Kasım kampanyalarına en güçlü şekilde hazırlanarak satışlarınızı katlayın!',
          image: 'category',
        },
        {
          title: 'Kampanyada Yer Almak İçin Promosyon Araçlarını Kullanın!',
          desc: 'Kupondan indirim oluşturmaya, flaş tekliflerden kampanyalara bir çok promosyon aracıyla dilediğiniz promosyon ekranıyla satışlarınızı katlayabilirsiniz!',
          image: 'ticket',
        },
        {
          title: 'Görünürlüğünüzü Artırarak Müşterilerinizin Dikkatini Çekin!',
          desc: 'Reklam vererek görünürlüğünüzü artırabilir, hızlı teslimat etiketiyle müşterilerimizin %84\'ünü alışveriş yapmaya motive edebilir ve mağaza tasarımınızı yenileyerek Trendyol\'daki sayfanızı sürekli ilgi çekici kılabilirsiniz!',
          image: 'ads',
        },
        {
          title: 'Anlık Aksiyonlar Alarak Kampanya Performansınızı Artırın!',
          desc: 'Kampanya döneminde hızlı aksiyonlar almak için Canlı Performansım olmazsa olmaz! Performansınızı takip ederken hedeflerinizi de tamamlayıp güzel bir kampanya dönemi geçirin!',
          image: 'report',
        },
      ],
      comments: [
        {
          title: 'TeknoReyonum ',
          desc: 'Kasım kampanyaları işimize çok olumlu yansıyor ve siparişlerimizde 10 kata kadar bir iş artışı oluyor. Bütün yıl kasım ayını bekliyoruz! Teşekkürler.',
          image: '119205',
        },
        {
          title: 'FARMAKOZMETİKA',
          desc: 'Merhabalar, yoğun, bol satışlı ve keyifli geçen bir kampanya dönemi bizim için!',
          image: '214643',
        },
        {
          title: 'Smyrna Wear',
          desc: 'Tüm yıl Kasım ayını bekliyor ve Kasım kampanyalarını düşünerek stok kontrolü yapıyoruz. Tüm yılın en yüksek cirosunu hedefliyoruz. Teşekkürler Trendyol!',
          image: '183683',
        },
      ],
    };
  },
  mounted() {
    window.dataLayer.push({
      event: 'content-view',
      'content-name': this.$route.fullPath,
      'content-view-name': this.$route.name,
    });
  },
  methods: {
    sendGtmData(action) {
      window.dataLayer.push({
        event: 'GAEvent',
        eventCategory: 'Kasım Page 2022',
        eventAction: action,
        eventLabel: window.user.supplierId,
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.header{
  color: #273142;
  font-size: 20px;
  line-height: 24px;
  margin-top: -30px;
  padding: 12px 24px;
  background-color: #FFFFFF;
}
.landing-page {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #F1F2F7;

  &.mobile-landing{
    margin-top: 0;
    .landing-page-bg{
      img{
        top: 0;
      }
    }
  }

  .landing-img{
    padding-right: 100px;
    @media only screen and (max-width: 960px){
      padding: 0;
      img{
        width: 150px;
      }
    }
  }

  .lp-box{
    padding-top: 60px;
  }

  &-banner {
    z-index: 1;
    display: flex;
    padding: 0 24px;
    justify-content: space-between;
  }

  &-bg{
    width: 100%;
    img{
      left: 0;
      right: 0;
      top: 90px;
      z-index: 0;
      width: 100%;
      height: auto;
      margin: 0 auto;
      position: absolute;

      @media only screen and (max-width: 960px){
        height: 550px;
      }
    }
  }

  &-head {
    z-index: 1;
    width: 70%;
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: flex-start;

    h1 {
      color: #ffffff;
      font-size: 48px;
      font-weight: 500;
      margin-left: 24px;
      @media only screen and (max-width: 960px){
        margin: 0;
        width: 100%;
        font-size: 24px;
        text-align: left;
      }
    }

    .cta-wrapper{
      display: flex;
      margin: 60px 0 0 24px;
      a{
        color: #273142;
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        border-radius: 6px;
        margin-right: 20px;
        padding: 12px 20px;
        text-decoration: none;
        box-sizing: border-box;
        background-color: #FFFFFF;
      }
      @media only screen and (max-width: 960px){
        width: 100%;
        margin-left: 0;
        margin-top: 10px;
        flex-direction: column;
        a{
          width: 100%;
          margin: 10px 0 10px 0;
          text-align: center;

          &:last-child,&:first-child{
            display: none;
          }
        }
      }
    }
  }

  &-image {
    z-index: 1;
    flex: 1 1 auto;
    text-align: center;
    position: relative;

    img {
      right: 0;
      width: 100%;
      height: auto;
      position: relative;
    }

    @media only screen and (max-width: 960px){
      max-width: 30%;
      text-align: center;
    }
  }

  .third-section{
    padding: 36px 54px 32px 0;
    background: #F1F2F7;

    .badge-image{
      display: flex;
      padding-bottom: 38px;
      justify-content: center;
    }

    .card-wrapper{
      display: flex;
      flex-wrap: wrap;
      .section-card{
        width: 50%;
        display: flex;
        margin-top: 48px;
        align-items: center;
        .info{
          display: flex;
          flex-direction: column;
          .title{
            color: #273142;
            font-size: 20px;
            font-weight: 500;
            line-height: 24px;
          }
          .desc{
            font-size: 16px;
            margin-top: 24px;
            line-height: 20px;
          }
        }
        &:nth-child(-n + 2) {
          margin-top: 0;
        }
      }
    }
    @media only screen and (max-width: 960px){
      padding: 32px 16px;
      .card-wrapper{
        flex-direction: column;
        justify-content: center;
        .section-card{
          width: 100%;
          text-align: center;
          flex-direction: column;
          justify-content: center;
        }
      }
    }
  }

  &-boxes {
    z-index: 1;
    display: flex;
    margin-top: 48px;
    padding: 32px 24px;
    position: relative;
    flex-direction: column;
    background-color: #F1F2F7;
    justify-content: space-between;

    .box-title{
      color: #273142;
      font-size: 20px;
      font-weight: 500;
    }

    .info-box {
      padding: 16px;
      display: flex;
      border-radius: 6px;
      background-color: #fff;
      flex-direction: column;
      align-items: flex-start;
      width: calc(25% - 24px);
      justify-content: space-between;

      &-wrapper{
        display: flex;
        margin-top: 24px;
        justify-content: space-between;

        .info-box-cta{
          width: 100%;
          display: flex;
          flex-direction: column;

          .desc-w-icon{
            display: flex;
            align-items: center;
            .icon{
              padding: 16px;
              border-radius: 4px;
            }
            .desc-box{
              display: flex;
              margin-left: 16px;
              flex-direction: column;
              .title{
                color: #273142;
                font-size: 14px;
                font-weight: 500;
              }
              .desc{
                color: #6E7787;
                font-size: 12px;
                margin-top: 8px;
              }
            }
          }
        }

        @media only screen and (max-width: 960px){
          flex-direction: column;
          .info-box {
            width: 100%;
            margin-top: 20px;
            box-sizing: border-box;
          }
        }
      }

      img{
        width: 100%;
        margin-top: 16px;
        border-radius: 4px;
      }
      h3 {
        color: #273142;
        font-size: 16px;
        font-weight: 500;
        margin: 10px 0 0 0;
      }

      p {
        color: #6E7787;
        margin: 10px 0;
      }

      a {
        text-decoration: none;
      }
    }

    &.cta-box{
      margin-top: 0;
      padding-top: 0;
      background-color: transparent;

      .box-title{
        color: #fff;
        padding-top: 32px;
        padding-bottom: 24px;
      }

      .info-box-wrapper{
        margin-top: 0;
        .info-box {
          border: none;
          padding: 16px;
          display: flex;
          align-items: center;
          .box-icon{
            padding: 12px;
            border-radius: 4px;
            background-color: #F7F7FA;
          }
          p {
            color: #273142;
            margin: 16px 0;
            font-size: 12px;
            text-align: center;
          }
          a {
            width: 100%;
            color: #FFFFFF;
            padding: 8px 0;
            font-size: 14px;
            font-weight: 500;
            line-height: 16px;
            text-align: center;
            border-radius: 4px;
            text-decoration: none;
            background-color: #F27A1A;
          }
        }
      }
    }
  }

  .slider-section {
    padding: 32px 20px;
    position: relative;

    .title{
      display: flex;
      color: #ffffff;
      font-size: 20px;
      font-weight: 500;
      align-items: center;
      margin-bottom: 28px;
      justify-content: space-between;
    }

    .comment-wrapper{
      display: flex;
      justify-content: space-between;
      .slider-item{
        display: flex;
        padding: 16px;
        border-radius: 6px;
        flex-direction: column;
        width: calc(33.3333% - 24px);
        background-color: #FFFFFF;
        .top{
          display: flex;
          align-items: center;
          img{
            width: 40px;
            height: auto;
            border-radius: 20px;
          }
          .customer{
            display: flex;
            padding-left: 8px;
            flex-direction: column;
            &-name{
              color: #273142;
              font-size: 16px;
              font-weight: 500;
              line-height: 20px;
            }
            &-title{
              color: #95A1B5;
              font-size: 12px;
              line-height: 14px;
            }
          }
        }
        .comment{
          color: #273142;
          font-size: 14px;
          line-height: 16px;
          margin-top: 24px;
        }
      }
      @media only screen and (max-width: 960px){
        flex-direction: column;
        .slider-item{
          width: 100%;
          box-sizing: border-box;
          &:not(:first-child){
            margin-top: 16px;
          }
        }
      }
    }
  }
  .footer{
    color: #95A1B5;
    font-size: 14px;
    line-height: 16px;
    padding: 20px 24px;
    background-color: #FFFFFF ;
  }
}
</style>
